import script from "./SavedToSpendPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavedToSpendPage.vue?vue&type=script&setup=true&lang=ts"

import "./SavedToSpendPage.vue?vue&type=style&index=0&id=8f102d76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f102d76"]])

export default __exports__